import { isToday, isTomorrow, format } from "date-fns";
import FilterHelpers from "helpers/filter-helpers";
import { parseISOWithoutTime } from "helpers/date-helpers";
import MembershipHelpers from "helpers/membership-helpers";
import ActionLogger from "action-logger";
import Constants from "rtr-constants";

const availabilityPreferencesModalHelpers = {
  basePixel: function (props) {
    const {
      analyticsObjectType,
      analyticsOpenedFrom,
      membershipState,
      userData: { memberships },
    } = props;
    return {
      object_type: analyticsObjectType,
      membership: MembershipHelpers.getMembershipTypeAnalytics(memberships, membershipState),
      pro: memberships?.isProMember || false,
      opened_from: analyticsOpenedFrom,
    };
  },

  logNotEligibleSkus: function (props) {
    const ineligibleItems = this.membershipBagIneligibleItems(props);
    return JSON.stringify(ineligibleItems);
  },

  logShowWarning: function (props) {
    const logData = {
      action: "switch_not_eligible_error",
      skus_not_eligible: this.logNotEligibleSkus(props),
      ...this.basePixel(props),
    };
    ActionLogger.logAction(logData);
  },

  logWarningResponse: function (props, response) {
    const logData = {
      action: "switch_not_eligible_response",
      skus_not_eligible: this.logNotEligibleSkus(props),
      response: response,
      ...this.basePixel(props),
    };

    ActionLogger.logAction(logData);
  },

  logFilterAction: function (props, method, allFilters) {
    const logData = {
      action: "apply_availability_filter",
      filter_method: method,
      new_view: FilterHelpers.pixelFilterParam(allFilters, props.userData),
      ...this.basePixel(props),
    };

    ActionLogger.logAction(logData);
  },

  fetchStreet: function (props) {
    const { membershipState } = props;

    if (MembershipHelpers.isActiveMembership(membershipState)) {
      return membershipState?.address?.street1;
    }
  },

  formatDate: function (date, formatPreText = "") {
    if (!date) return "";
    const delivery = parseISOWithoutTime(date);
    if (isToday(delivery)) return `Today, ${format(delivery, Constants.dateFnsFormats.M_D)}`;
    if (isTomorrow(delivery)) return `Tomorrow, ${format(delivery, Constants.dateFnsFormats.M_D)}`;
    return `${formatPreText} ${format(delivery, "cccc")}, ${format(delivery, Constants.dateFnsFormats.M_D)}`;
  },
};

export default availabilityPreferencesModalHelpers;

export const {
  basePixel,
  logNotEligibleSkus,
  logShowWarning,
  logWarningResponse,
  logFilterAction,
  fetchStreet,
  formatDate,
} = availabilityPreferencesModalHelpers;
